
import { Vue, Component, Prop } from "vue-property-decorator";
import { v4 as uuid } from "uuid";

import GET_EXPERIENCES from "@/apollo/profile/experiences/GetExperiences.gql";
import CREATE_USER_EXPERIENCE from "@/apollo/profile/experiences/CreateExperience.gql";

import ProfileExperienceCard from "@/components/profile/experiences/ProfileExperienceCard.vue";
import ExperienceModal from "@/components/profile/experiences/ExperienceModal.vue";
import UIButton from "@/components/button/ui-button.vue";
import FormWrapper from "@/components/form/FormWrapper.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";

import { Experience_Skill_Aggregate, User, User_Experience } from "@/generated/graphql";
import UserResume from "@/entities/UserResume";

@Component({
  components: {
    ProfileExperienceCard,
    ExperienceModal,
    UIButton,
    FormWrapper,
    LoadingOverlay,
  },
  apollo: {
    experiences: {
      query: GET_EXPERIENCES,
      variables() {
        return {
          id: this.userId,
        };
      },
      update: (data) => {
        return data.user_by_pk.experiences;
      },
    },
  },
})
export default class ProfileExperience extends Vue {
  @Prop({ type: String, required: true }) readonly userId!: string;

  experiences?: User_Experience[] = undefined;

  isModalOpen: boolean = false;

  showModal(): void {
    this.isModalOpen = true;
  }

  refresh(): void {
    this.$apollo.queries.experiences.refetch();
    this.$emit("update");
  }

  /**
   * ==========================[qtrinh@ideatheorem.com]==========================
   * Add experience here
   */
    created() {
    this.$eventBus.listen(UserResume.UPDATE_RESUME, (data: any) => {
      const scrappedResume = data.data
      if (scrappedResume)
      {
        if (scrappedResume.hasOwnProperty("workExperience") && scrappedResume.workExperience && scrappedResume.workExperience.length > 0)
        {


          scrappedResume.workExperience.map( async (exp) =>
          {
            let experience: User_Experience = {
              id: uuid(),
              user_id: this.userId,
              job_title: exp.jobTitle,
              company_name: exp.organization,
              employment_type: '',
              ongoing: !exp.dates?.endDate ? true : false,
              location: exp.location ? exp.location.rawInput : "",
              summary: exp.jobDescription,
              start_date: exp.dates?.startDate,
              end_date: exp.dates?.endDate,
              industry_id: null,
              added_by_id: this.userId,
              created_at: new Date(),
              skills : [],
              skills_aggregate: null,
              user: null
            }

            this.experiences.push(experience)

            await this.$apollo.mutate({
              mutation: CREATE_USER_EXPERIENCE,
              variables: {
                experienceSet: {
                  ...{
                    id: uuid(),
                    user_id: this.userId,
                    job_title: exp.jobTitle,
                    company_name: exp.organization,
                    employment_type: '',
                    ongoing: !exp.dates?.endDate ? true : false,
                    location: exp.location ? exp.location.rawInput : "",
                    summary: exp.jobDescription,
                    start_date: exp.dates?.startDate,
                    end_date: exp.dates?.endDate
                  },
                  skills: {
                    data: []
                  },
                },
              },
            });
          })
        }
      }
    })
  }

  beforeDestroy() {
    this.$eventBus.remove(UserResume.UPDATE_RESUME)
  }
  /**
   * ==========================[qtrinh@ideatheorem.com]==========================
   */
}
